import { FlatListGridProps } from './FlatListGridProps'
import { Grid } from '../Grid'
import { YStack } from '@mythical/ui'

export const FlatListGrid = <T,>(props: FlatListGridProps<T>) => {
  const { items, wrapperProps, innerWrapperProps, ListFooterComponent, ListHeaderComponent } = props

  return (
    <YStack w='100%' {...wrapperProps}>
      {ListHeaderComponent}
      <Grid {...props} wrapperProps={innerWrapperProps} items={items} />
      {ListFooterComponent}
    </YStack>
  )
}
